import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/base/SEO';
import { siteInfo } from '@/mocks/tvSeries';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50">
      <SEO
        title={`页面未找到 - ${siteInfo.name}`}
        description="抱歉，您访问的页面不存在。请返回草民影院首页浏览最新电视剧。"
        canonicalUrl="https://caomin.tv"
      />
      <Navbar />

      <main className="pt-20 max-w-[1280px] mx-auto px-4 md:px-6 py-20 text-center">
        <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center rounded-full bg-background-200 text-foreground-400">
          <i className="ri-emotion-sad-line text-3xl"></i>
        </div>
        <h1 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
          404 - 页面未找到
        </h1>
        <p className="text-foreground-600 mb-8 max-w-md mx-auto">
          抱歉，您访问的页面不存在或已被移除。别担心，还有很多精彩剧集等着您！
        </p>
        <div className="flex items-center justify-center gap-4 flex-wrap">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 rounded-lg text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-home-line text-base"></i>
            </span>
            返回首页
          </Link>
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-100 text-foreground-700 rounded-lg text-sm font-semibold border border-background-300 hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-movie-2-line text-base"></i>
            </span>
            浏览剧集
          </Link>
        </div>
      </main>

      <Footer />
    </div>
  );
}